<script setup lang="ts">
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { onMounted, computed } from 'vue'
import { gtm_sub_upgrade_dialog } from '@/helpers/gtm'
import DialogTemplate from '@/components/Dialogs/DialogTemplate.vue'
import UpdatePaymentPlan from '@/components/Dialogs/UpdatePaymentPlanDialog/UpdatePaymentPlan.vue'
import { PortalTarget } from 'portal-vue'

const store = useStore()
const route = useRoute()
const startAtStep = computed(() => (route.query.pending_payment === 'true' ? 2 : 1))

onMounted(() => {
  gtm_sub_upgrade_dialog({
    subpage: store.state.router.from_path_name || route.name,
  })
})
</script>

<template>
  <DialogTemplate
    class="update-dialog"
    data-tst="update-payment-plan-dialog"
  >
    <UpdatePaymentPlan
      :startAtStep
      view="dialog"
    />
    <template #dialog_actions>
      <portal-target name="update_payment_dialog_actions" />
    </template>
  </DialogTemplate>
</template>

<style lang="scss" scoped>
.update-dialog {
  width: 48rem;
  max-width: calc(100vw - 2rem);
  transition: 0.4s ease;
}
.update-step {
  // padding: 1rem;
  width: 100%;
  &_step {
    &_title {
      font-size: 1.5rem;
      font-weight: 700;
      white-space: nowrap;
    }
    &_sub {
      display: flex;
      font-size: 1rem;
    }
  }
}
.update-steps {
  // position: absolute;
  // bottom: 0;
  // width: 100%;
  font-size: 0.8rem;
  color: var(--clr-grey-2);
  padding: 0 1rem;
}
.switch-to-yearly {
  cursor: pointer;
  color: var(--clr-primary);
  &:hover {
    text-decoration: underline;
  }
}

.tier-tag {
  border-radius: 4px;
  font-weight: 700;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  flex: 0;
  &_trial {
    color: var(--clr-white-0);
  }
  &_starter {
    color: var(--clr-blue);
  }
  &_premium {
    color: var(--clr-yellow);
  }
  &_icon {
    font-size: 1.5rem;
    margin: 0 0.5rem 0 0;
    color: currentColor;
  }
}
</style>
